<div class="padding text--center" data-price-info-window>
    <div class="margin-bottom"><%= isRentalType ? 'Loyer' : 'Prix' %> m<sup>2</sup> moyen <%= place.name %></div>

    <% if (shouldShowApartmentPrice) { %>
    <div class="inline-block margin-right">Appartement <span class="text--bold title--h4"><%= apartmentPrice %></span></div>
    <% } %>

    <% if (shouldShowHousePrice) { %>
    <div class="inline-block">Maison <span class="text--bold title--h4"><%= housePrice %></span></div>
    <% } %>
</div>
